import Api from './axiosInstance'
import { API_INVENTORY } from 'utils/constants'

type FetchInventoryParams = {
  limit: number
  page: number
  search?: string
  filters?: any
}

const fetchInventoryDetails = ({
  limit,
  page,
  search,
  filters,
}: FetchInventoryParams) => {
  let options: any = {}

  if (search) {
    options.search = search
  }

  if (filters) {
    options = { ...options, ...filters }
  }

  const params = new URLSearchParams({
    limit,
    page,
    ...options,
  })
  return Api.get({
    url: `${API_INVENTORY.INVENTORY}?${params}`,
  })
}

const getInventory = (id: string) => {
  return Api.get({ url: `${API_INVENTORY.INVENTORY}/${id}` })
}

const updateInventory = (id: string, data: any) => {
  return Api.patch({
    url: `${API_INVENTORY.INVENTORY}/${id}`,
    data: data,
  })
}

const importInventory = async (data: any) => {
  return Api.post({
    url: API_INVENTORY.INVENTORY_IMPORT,
    data: data,
    headers: { 'Content-Type': 'multipart/form-data' },
  })
}

const downloadInventory = ({ filters }: { filters: Record<string, any> }) => {
  const params = new URLSearchParams(filters)
  return Api.get({
    url: `${API_INVENTORY.INVENTORY_EXPORT}?${params}`,
  })
}

export {
  fetchInventoryDetails,
  updateInventory,
  getInventory,
  importInventory,
  downloadInventory,
}
